import React from "react";

export default function LoadingOverlay({ isLoading, text = "در حال بارگذاری..." }) {
  if (!isLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999999, // تضمینی بالا همه
      }}
    >
      <div
        style={{
          background: "white",
          padding: "30px 50px",
          borderRadius: "15px",
          textAlign: "center",
          boxShadow: "0 0 20px rgba(0,0,0,0.4)",
          fontFamily: "sans-serif",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "5px solid #ccc",
            borderTop: "5px solid #007bff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 15px auto",
          }}
        />
        <p style={{ color: "#333", fontSize: "16px", margin: 0 }}>{text}</p>

        <style>
          {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
        </style>
      </div>
    </div>
  );
}
